import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React, { Fragment } from 'react';
import { Row, Col } from 'react-bootstrap';
import moment from 'moment';
import PropTypes from 'prop-types';
import Geosuggest from '@ubilabs/react-geosuggest';
import DatePicker from 'react-datepicker';
import Select from 'react-select';
import { useDispatch } from 'react-redux';
import Question from '../Question';
import MultiSelectInput from '../MultiSelectInput';
import TextAreaInput from '../TextAreaInput';
import RadioInputGroup from '../RadioInputGroup';
import RateInput from '../RateInput';
import ErrorMessageField from '../ErrorMessageField';
import DocumentUpload from '../../DocumentUpload';
import PastRolesQuestion from '../PastRolesQuestion';
import ListForm from '../ListForm';
import GroupParentForm from '../GroupParentForm';
import DropdownIndicator from '../DropdownIndicator';
import ProficiencyTagRanking from '../ProficiencyTagRanking';
import dropdownStyleUtils from '../../../dropdownStyleUtils';
import { getRequest } from '../../../requestUtils';
import allActions from '../../../actions';
import { analyticsTrack } from '../../../analyticsUtils';
import '../Question/Question.scss';
var profileSuggestions = allActions.profileSuggestions;
var renderFileUpload = function renderFileUpload(text, subText, resumeUrl, resume, key, csrfToken, forceSmallQuestionTitle, style, onboardingQuestionnaire, handleMenuUpdate, handleNewResume, handleResumeUpload, userId) {
  return /*#__PURE__*/React.createElement(Question, {
    title: text,
    titleStyleClass: "mb-8",
    subtext: subText,
    isBig: forceSmallQuestionTitle !== true,
    questionKey: key,
    location: onboardingQuestionnaire ? 'onboarding' : 'profile-edit'
  }, /*#__PURE__*/React.createElement(DocumentUpload, {
    location: onboardingQuestionnaire ? 'Onboarding Flow' : 'Consultant Profile',
    prompt: "Upload Resume",
    viewDocumentUrl: resume && "/resumes/".concat(resume.resource_id),
    uploadDocumentUrl: resumeUrl,
    csrfToken: csrfToken,
    documentType: "parsedResume",
    userId: userId,
    document: resume,
    handleMenuUpdate: handleMenuUpdate,
    handleNewResume: handleNewResume,
    buttonStyle: "button",
    handleResumeUpload: handleResumeUpload
  }));
};
var renderTextArea = function renderTextArea(text, subText, parent, answer, key, handleChange, forceSmallQuestionTitle, onboardingQuestionnaire) {
  return /*#__PURE__*/React.createElement(Question, {
    title: text,
    titleStyleClass: "mb-8",
    isBig: forceSmallQuestionTitle !== true && parent === null,
    subtext: subText,
    location: onboardingQuestionnaire ? 'onboarding' : 'profile-edit'
  }, /*#__PURE__*/React.createElement(TextAreaInput, {
    className: "form-control fs-hide",
    placeholder: key === 'bio' ? 'Type your bio here...' : 'Type here...',
    rows: 5,
    value: answer !== null ? answer : '',
    required: false,
    onAnswerChange: function onAnswerChange(v) {
      return handleChange(v, key);
    },
    textAreaPrompt: ""
  }));
};
var styleInputGroup = {
  wrapper: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'flex-end',
    paddingRight: '64px',
    flex: 'none',
    order: 2,
    alignSelf: 'stretch',
    flexGrow: 0,
    zIndex: 0
  },
  input: {
    boxSizing: 'border-box',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '0px 8px 0px 16px',
    gap: '8px',
    height: '40px',
    background: '#FFFFFF',
    border: '1px solid #242424',
    borderRadius: '2px 0px 0px 2px',
    flex: 'none',
    order: 1,
    alignSelf: 'stretch',
    flexGrow: 0
  },
  button: {
    boxSizing: 'border-box',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '0px 8px',
    height: '40px',
    borderRadius: '0px 4px 4px 0px',
    border: '1px solid #00A88C',
    flex: 'none',
    order: 1,
    flexGrow: 0
  }
};
var renderTextInputGroupSuffix = function renderTextInputGroupSuffix(text, subText, parent, answer, key, addon, addonUrl, handleChange, forceSmallQuestionTitle, csrfToken, onboardingQuestionnaire, userId) {
  var dispatch = useDispatch();
  var onVerify = function onVerify() {
    getRequest(addonUrl, {}, csrfToken).then(function (response) {
      if (response.data) {
        dispatch(profileSuggestions.linkedinProfileParsed(response.data));
      }
    });
  };
  var onFocus = function onFocus() {
    analyticsTrack('Indication linkedin', {
      onboardingQuestionnaire: onboardingQuestionnaire,
      userId: userId
    });
  };
  return /*#__PURE__*/React.createElement(Question, {
    title: text,
    titleStyleClass: "mb-8",
    subtext: subText,
    isBig: forceSmallQuestionTitle !== true && parent === null,
    questionKey: key,
    location: onboardingQuestionnaire ? 'onboarding' : 'profile-edit'
  }, /*#__PURE__*/React.createElement("div", {
    style: styleInputGroup.wrapper
  }, /*#__PURE__*/React.createElement("input", {
    type: "text",
    id: "".concat(key, "-question-text-input"),
    style: styleInputGroup.input,
    placeholder: key === 'linkedin' ? 'Paste LinkedIn URL' : 'Write here...',
    value: answer !== null ? answer : '',
    required: false,
    onChange: function onChange(v) {
      return handleChange(v.target.value, key);
    },
    onFocus: onFocus
  }), addon && /*#__PURE__*/React.createElement("button", {
    disabled: key === 'linkedin' && (answer === null || !answer.match(/linkedin\.com/i)),
    onClick: function onClick() {
      return onVerify();
    },
    className: "btn btn-secondary-dark",
    style: styleInputGroup.button
  }, addon)));
};
var renderTextInput = function renderTextInput(text, subText, parent, answer, key, handleChange, forceSmallQuestionTitle, onboardingQuestionnaire) {
  return /*#__PURE__*/React.createElement(Question, {
    title: text,
    titleStyleClass: "mb-8",
    subtext: subText,
    isBig: forceSmallQuestionTitle !== true && parent === null,
    questionKey: key,
    location: onboardingQuestionnaire ? 'onboarding' : 'profile-edit'
  }, /*#__PURE__*/React.createElement("input", {
    type: "text",
    id: "".concat(key, "-question-text-input"),
    className: "form-control fs-hide mt-3",
    placeholder: key === 'linkedin' ? 'Paste your LinkedIn URL here' : 'Write here...',
    value: answer !== null ? answer : '',
    required: false,
    onChange: function onChange(v) {
      return handleChange(v.target.value, key);
    }
  }));
};
var renderList = function renderList(questionText, subtext, answer, questionKey, handleChange, limit, closeModal, style) {
  return /*#__PURE__*/React.createElement(Question, {
    title: questionText,
    titleStyleClass: "mb-8",
    subtext: subtext,
    isBig: true
  }, /*#__PURE__*/React.createElement(ListForm, {
    answer: answer || [''],
    questionKey: questionKey,
    handleChange: handleChange,
    limit: limit,
    closeModal: closeModal,
    style: style
  }));
};
var renderNumericRangeTextInput = function renderNumericRangeTextInput(text, subText, parent, answer, key, handleChange, forceSmallQuestionTitle, onboardingQuestionnaire, userId, updateParentError) {
  var mapping = {
    hourly_rate_range: 'Indicating Rate Value',
    availability: 'Indicating hours per week Value'
  };
  var validRange = function validRange() {
    if (answer !== null) {
      var min = parseInt(answer.low, 10);
      var max = parseInt(answer.high, 10);
      return min >= 0 && max >= 0 ? min <= max : false;
    }
    return true;
  };
  var validRate = function validRate() {
    if (answer) {
      if (answer.low && answer.low.toString().includes('.')) {
        return false;
      }
      if (answer.high && answer.high.toString().includes('.')) {
        return false;
      }
    }
    return true;
  };
  var onChange = function onChange(v, position, minOrMax) {
    handleChange(v, key, position);
    if (key === 'hourly_rate_range' || key === 'availability') {
      updateParentError(!validRate() || !validRange());
    }
    analyticsTrack("".concat(mapping[key], " - ").concat(text, " - ").concat(minOrMax), {
      location: onboardingQuestionnaire ? 'Onboarding Flow' : 'Not Onboarding Flow',
      questionKey: key,
      userId: userId
    });
  };
  var errorMessage = null;
  if (!validRate()) {
    errorMessage = 'Please enter whole numbers only.';
  } else if (!validRange()) {
    errorMessage = 'The maximum value must be larger than the minimum value.';
  }
  return /*#__PURE__*/React.createElement(Question, {
    title: key === 'availability' ? '' : text,
    titleStyleClass: "mb-8",
    subtext: subText,
    isBig: forceSmallQuestionTitle !== true && parent === null,
    location: onboardingQuestionnaire ? 'onboarding' : 'profile-edit'
  }, /*#__PURE__*/React.createElement("div", {
    className: "g-row ".concat(onboardingQuestionnaire ? "onboarding-".concat(key) : '')
  }, /*#__PURE__*/React.createElement(RateInput, {
    id: "low-end-hourly-range-input",
    value: answer !== null ? answer.low : '',
    onAnswerChange: function onAnswerChange(v) {
      return onChange(v, 'low', 'Minimum');
    },
    placeholder: "Low End",
    onboardingQuestionnaire: onboardingQuestionnaire,
    minOrMax: "Minimum",
    inputClass: "mt-2 ".concat(key),
    allowDecimals: false
  }, key === 'hourly_rate_range' && /*#__PURE__*/React.createElement("span", {
    className: "input-group-addon ".concat(onboardingQuestionnaire ? 'addon-bg-color' : '')
  }, "$")), /*#__PURE__*/React.createElement(RateInput, {
    id: "high-end-hourly-range-input",
    value: answer !== null ? answer.high : '',
    onAnswerChange: function onAnswerChange(v) {
      return onChange(v, 'high', 'Maximum');
    },
    placeholder: "High End",
    onboardingQuestionnaire: onboardingQuestionnaire,
    minOrMax: "Maximum",
    inputClass: "mt-2 ".concat(key),
    allowDecimals: false
  }, key === 'hourly_rate_range' && /*#__PURE__*/React.createElement("span", {
    className: "input-group-addon ".concat(onboardingQuestionnaire ? 'addon-bg-color' : '')
  }, "$"))), /*#__PURE__*/React.createElement(ErrorMessageField, {
    errorMessage: errorMessage,
    showMessage: errorMessage
  }));
};
var renderDateRangeDateInput = function renderDateRangeDateInput(text, subText, parent, answer, key, handleChange, forceSmallQuestionTitle, onboardingQuestionnaire) {
  var toDate = function toDate(date) {
    return moment(date).utc(true).toDate();
  };
  var invalidDate = function invalidDate() {
    if (answer !== null) {
      if (toDate(answer.start_date) === null) return false;
      if (toDate(answer.end_date) !== null && toDate(answer.end_date) > toDate(answer.start_date)) {
        return false;
      }
    }
    return true;
  };
  return /*#__PURE__*/React.createElement(Question, {
    title: key === 'available_when' ? '' : text,
    titleStyleClass: "mb-8",
    subtext: subText,
    isBig: forceSmallQuestionTitle !== true && parent === null,
    location: onboardingQuestionnaire ? 'onboarding' : 'profile-edit'
  }, /*#__PURE__*/React.createElement("div", {
    className: "g-row ".concat(onboardingQuestionnaire ? "onboarding-".concat(key) : '')
  }, /*#__PURE__*/React.createElement("div", {
    className: "g-row--always calendar-".concat(key)
  }, /*#__PURE__*/React.createElement("span", null, "Starting"), /*#__PURE__*/React.createElement(DatePicker, {
    selected: answer && answer.start_date ? toDate(answer.start_date) : null,
    onChange: function onChange(v) {
      return handleChange(v, key, 'start_date');
    },
    allowSameDay: true,
    className: "form-control calendar-".concat(key, " ").concat(onboardingQuestionnaire ? 'onboarding-input-edges' : ''),
    value: answer && answer.start_date ? toDate(answer.start_date) : moment().toDate(),
    dateFormat: "MM/dd/yyyy",
    placeholderText: "Click to select a date"
  })), /*#__PURE__*/React.createElement("div", {
    className: "g-row--always calendar-".concat(key)
  }, /*#__PURE__*/React.createElement("span", null, "Ending"), /*#__PURE__*/React.createElement(DatePicker, {
    selected: answer && answer.end_date ? toDate(answer.end_date) : null,
    onChange: function onChange(v) {
      return handleChange(v, key, 'end_date');
    },
    allowSameDay: true,
    className: "form-control calendar-".concat(key, " ").concat(onboardingQuestionnaire ? 'onboarding-input-edges' : ''),
    value: answer && answer.end_date ? toDate(answer.end_date) : moment().toDate(),
    dateFormat: "MM/dd/yyyy",
    placeholderText: "Click to select a date"
  }))), /*#__PURE__*/React.createElement(ErrorMessageField, {
    errorMessage: "Starting date is required and must be before ending date.",
    showMessage: invalidDate()
  }));
};
var renderNumberInput = function renderNumberInput(text, subText, parent, answer, key, handleChange, forceSmallQuestionTitle, onboardingQuestionnaire) {
  return /*#__PURE__*/React.createElement(Question, {
    title: text,
    titleStyleClass: "mb-8",
    subtext: subText,
    isBig: forceSmallQuestionTitle !== true && parent === null,
    questionKey: key,
    location: onboardingQuestionnaire ? 'onboarding' : 'profile-edit'
  }, /*#__PURE__*/React.createElement("div", {
    className: "g-row--always ".concat(onboardingQuestionnaire ? key : '')
  }, /*#__PURE__*/React.createElement("input", {
    type: "number",
    id: "".concat(key, "-number-input"),
    className: "form-control number-input ".concat(onboardingQuestionnaire ? 'onboarding-input-edges' : ''),
    value: answer !== null ? answer : '',
    onChange: function onChange(v) {
      return handleChange(v.target.value, key);
    }
  }), !onboardingQuestionnaire && /*#__PURE__*/React.createElement("span", {
    className: "body-text-2 ms-3 mt-2"
  }, key === 'years_of_experience' ? 'years' : 'hours per week')));
};
var renderGeosuggest = function renderGeosuggest(text, subText, parent, answer, key, handleChange, forceSmallQuestionTitle, onboardingQuestionnaire, userId) {
  var onChange = function onChange(obj) {
    analyticsTrack("Indicating [".concat(text, "]"), {
      location: onboardingQuestionnaire ? 'Onboarding Flow' : 'Not Onboarding Flow',
      userId: userId
    });
    handleChange(obj.label, key);
  };
  return /*#__PURE__*/React.createElement(Question, {
    title: text,
    titleStyleClass: "mb-8",
    subtext: subText,
    isBig: forceSmallQuestionTitle !== true && parent === null,
    questionKey: key,
    location: onboardingQuestionnaire ? 'onboarding' : 'profile-edit'
  }, /*#__PURE__*/React.createElement("div", {
    className: "input-field"
  }, /*#__PURE__*/React.createElement(Geosuggest, {
    initialValue: answer !== null ? answer : '',
    suggestItemClassName: "geosuggest-font",
    inputClassName: "input-base",
    placeholder: "Type your current location",
    onChange: function onChange(v) {
      return handleChange(v, key);
    },
    onSuggestSelect: function onSuggestSelect(obj) {
      return obj && onChange(obj);
    },
    autoActivateFirstSuggest: true
  })));
};
var renderGroupedRadio = function renderGroupedRadio(text, subText, parent, options, values, key, handleChange, forceSmallQuestionTitle, onboardingQuestionnaire, userId) {
  var onChange = function onChange(option) {
    analyticsTrack("Indicating ".concat(text), {
      location: onboardingQuestionnaire ? 'Onboarding Flow' : 'Not Onboarding Flow',
      userId: userId,
      questionKey: key,
      value: option
    });
    handleChange(option, key);
  };
  return /*#__PURE__*/React.createElement(Question, {
    title: text,
    titleStyleClass: "mb-8",
    subtext: subText,
    isBig: forceSmallQuestionTitle !== true && parent === null,
    location: onboardingQuestionnaire ? 'onboarding' : 'profile-edit'
  }, /*#__PURE__*/React.createElement(RadioInputGroup, {
    options: options,
    handleInputChange: function handleInputChange(option) {
      return onChange(option);
    },
    selected: values && values.value,
    name: key
  }));
};
var renderBooleanCheckbox = function renderBooleanCheckbox(text, subText, parent, isParent, value, key, label, handleChange, forceSmallQuestionTitle, onboardingQuestionnaire, userId) {
  var onChange = function onChange() {
    analyticsTrack("Indicating ".concat(text), {
      location: onboardingQuestionnaire ? 'Onboarding Flow' : 'Not Onboarding Flow',
      userId: userId,
      questionKey: key,
      action: value === 'true' ? 'Indicating' : label
    });
    handleChange("".concat(!(value === 'true')), key);
  };
  return /*#__PURE__*/React.createElement(Question, {
    title: text,
    titleStyleClass: "mb-8",
    subtext: subText,
    isBig: forceSmallQuestionTitle !== true && parent === null,
    isParent: isParent,
    location: onboardingQuestionnaire ? 'onboarding' : 'profile-edit'
  }, /*#__PURE__*/React.createElement("label", {
    className: "custom-checkbox-container body-text-2",
    htmlFor: "boolean"
  }, /*#__PURE__*/React.createElement("input", {
    type: "checkbox",
    id: "boolean",
    defaultChecked: value === 'true',
    onClick: function onClick() {
      return onChange();
    }
  }), /*#__PURE__*/React.createElement("span", {
    className: "checkmark"
  }), /*#__PURE__*/React.createElement("span", {
    className: "label"
  }, label)));
};
var renderSingleSelect = function renderSingleSelect(title, subtext, answer, key, answerOptions, handleChange) {
  return /*#__PURE__*/React.createElement(Question, {
    title: title,
    subtext: subtext,
    titleStyleClass: "mb-12",
    isBig: true
  }, /*#__PURE__*/React.createElement("div", {
    className: "single-dropdown"
  }, /*#__PURE__*/React.createElement(Select, {
    components: {
      DropdownIndicator: DropdownIndicator,
      IndicatorSeparator: function IndicatorSeparator() {
        return null;
      }
    },
    styles: _objectSpread({}, dropdownStyleUtils),
    placeholder: "Select hours",
    options: answerOptions,
    value: answer && answerOptions.find(function (o) {
      return o.value === answer.value;
    }),
    onChange: function onChange(v) {
      return handleChange(v, key);
    },
    classNamePrefix: "clora-select"
  })));
};
var renderMultiSelect = function renderMultiSelect(text, subtext, parent, options, values, key, handleChange, asyncUrl, disabled, hasOther, hasFilter, style, limit, onlyCustom, forceSmallQuestionTitle, suggestedAnswers, onboardingQuestionnaire, userId) {
  return /*#__PURE__*/React.createElement(Question, {
    title: text,
    titleStyleClass: "mb-8",
    isBig: forceSmallQuestionTitle !== true && parent === null,
    questionKey: key,
    location: onboardingQuestionnaire ? 'onboarding' : 'profile-edit'
  }, /*#__PURE__*/React.createElement(MultiSelectInput, {
    subtext: subtext,
    options: options,
    values: values !== null ? values : [],
    handleSelectChange: function handleSelectChange(option) {
      return handleChange(option, key);
    },
    asyncUrl: asyncUrl,
    disabled: disabled,
    hasOther: hasOther,
    hasFilter: hasFilter,
    style: style,
    limit: limit,
    onlyCustom: onlyCustom,
    suggestedAnswers: suggestedAnswers,
    text: text,
    onboardingQuestionnaire: onboardingQuestionnaire,
    questionKey: key,
    userId: userId,
    closeOnSelect: onboardingQuestionnaire && key === 'roles'
  }));
};
var renderDateInput = function renderDateInput(text, subtext, parent, answer, key, handleChange, forceSmallQuestionTitle, onboardingQuestionnaire) {
  return /*#__PURE__*/React.createElement(Question, {
    title: text,
    className: key,
    isBig: forceSmallQuestionTitle !== true && parent === null,
    location: onboardingQuestionnaire ? 'onboarding' : 'profile-edit',
    questionKey: key
  }, /*#__PURE__*/React.createElement("label", {
    className: "g-row--always",
    htmlFor: "calendar-".concat(key)
  }, /*#__PURE__*/React.createElement(DatePicker, {
    selected: answer ? moment(answer).toDate() : null,
    onChange: function onChange(v) {
      return handleChange(v, key);
    },
    allowSameDay: true,
    className: "form-control calendar-".concat(key, " ").concat(onboardingQuestionnaire ? 'onboarding-input-edges' : ''),
    value: answer ? moment(answer).toDate() : moment().toDate(),
    dateFormat: "MM/dd/yyyy",
    placeholderText: "Click to select a date"
  })));
};
var renderPastRoles = function renderPastRoles(title, subtext, answer, key, handleChange, closeModal, forceSmallQuestionTitle, saveOnChange, suggestedAnswers, onboardingQuestionnaire, profileQuestionnaire, objectId, isReadingMore, handlePastRolesAfterUpdate) {
  return /*#__PURE__*/React.createElement(Question, {
    title: title,
    subtext: subtext,
    isBig: forceSmallQuestionTitle !== true,
    questionKey: key,
    location: onboardingQuestionnaire ? 'onboarding' : 'profile-edit'
  }, /*#__PURE__*/React.createElement(PastRolesQuestion, {
    questionKey: key,
    newPastRoles: suggestedAnswers && suggestedAnswers.length > 0 && answer.length === 0 ? suggestedAnswers : answer,
    handleChange: handleChange,
    closeModal: closeModal,
    saveOnChange: saveOnChange,
    onboardingQuestionnaire: onboardingQuestionnaire,
    profileQuestionnaire: profileQuestionnaire,
    objectId: objectId,
    isReadingMore: isReadingMore,
    handlePastRolesAfterUpdate: handlePastRolesAfterUpdate
  }));
};
var renderProficiencies = function renderProficiencies(title, subtext, answer, key, answerOptions, handleChange) {
  return /*#__PURE__*/React.createElement(Question, {
    title: title,
    subtext: subtext,
    titleStyleClass: "mb-12",
    isBig: true
  }, answer.map(function (ans, idx) {
    return /*#__PURE__*/React.createElement(Row, {
      className: "proficiency-input-row mb-8",
      key: "".concat(ans.value, "-proficiency"),
      id: "".concat(ans.value, "-proficiency")
    }, /*#__PURE__*/React.createElement(Col, {
      xs: 8
    }, ans.ranking && /*#__PURE__*/React.createElement("span", {
      className: "mr-6"
    }, ans.ranking, "."), /*#__PURE__*/React.createElement("span", {
      className: "badge green-light experience-tag"
    }, ans.label)), /*#__PURE__*/React.createElement(Col, {
      xs: 4,
      className: "proficiency-dropdowns"
    }, /*#__PURE__*/React.createElement(Select, {
      components: {
        DropdownIndicator: DropdownIndicator,
        IndicatorSeparator: function IndicatorSeparator() {
          return null;
        }
      },
      styles: _objectSpread({}, dropdownStyleUtils),
      placeholder: "Select years",
      options: answerOptions,
      value: answerOptions.find(function (o) {
        return o.value === ans.proficiency;
      }),
      onChange: function onChange(v) {
        return handleChange(v.value, key, idx);
      },
      classNamePrefix: "clora-select"
    })));
  }));
};
var renderProficiencyRankings = function renderProficiencyRankings(title, subtext, answer, rankedTagsCount, handleChange, questionKey) {
  return /*#__PURE__*/React.createElement(Question, {
    title: title,
    subtext: subtext,
    titleStyleClass: "mb-12",
    isBig: true
  }, /*#__PURE__*/React.createElement(ProficiencyTagRanking, {
    answer: answer,
    rankedTagsCount: rankedTagsCount,
    handleChange: handleChange,
    questionKey: questionKey
  }));
};
var renderGroupParent = function renderGroupParent(questionText, subtext, answer, questionKey, handleChange, limit, closeModal, childrenQuestions, parentId, disabled, handleMenuUpdate, onboardingQuestionnaire, userId) {
  return /*#__PURE__*/React.createElement(Question, {
    title: parentId ? null : questionText,
    titleStyleClass: "mb-8",
    subtext: subtext,
    disabled: disabled,
    isBig: true,
    location: onboardingQuestionnaire ? 'onboarding' : 'profile-edit',
    questionKey: questionKey
  }, /*#__PURE__*/React.createElement(GroupParentForm, {
    answers: answer,
    questionKey: questionKey,
    handleChange: handleChange,
    limit: limit,
    closeModal: closeModal,
    childrenQuestions: childrenQuestions,
    disabled: disabled,
    onboardingQuestionnaire: onboardingQuestionnaire,
    handleMenuUpdate: handleMenuUpdate,
    userId: userId
  }));
};
var renderQuestion = function renderQuestion(userId, question, handleChange, handleOtherTextChange, csrfToken, disabled, closeModal, forceSmallQuestionTitle, suggestedAnswers, saveOnChange, questionnaireName, handleMenuUpdate, handleNewResume, updateParentError, objectId, isReadingMore, handleResumeUpload, handlePastRolesAfterUpdate) {
  var onboardingQuestionnaire = questionnaireName === 'Consultant Onboarding';
  var profileQuestionnaire = questionnaireName === 'Consultant Profile';
  if (disabled && (question.trigger_type === 'hide' || question.trigger_type === 'show')) return null;
  switch (question.question_type) {
    case 'only_custom_tags':
    case 'select_many':
      return renderMultiSelect(question.question_text, question.subtext, question.parent_id, question.answer_options, question.answer, question.question_key, handleChange, question.async_url, disabled, question.has_other, question.has_filter, question.style, question.limit, question.question_type === 'only_custom_tags', forceSmallQuestionTitle, suggestedAnswers && suggestedAnswers[question.question_key], onboardingQuestionnaire, userId);
    case 'select_one':
      if (question.style === 'radio_oneline') {
        return renderGroupedRadio(question.question_text, question.subtext, question.parent_id, question.answer_options, question.answer, question.question_key, handleChange, forceSmallQuestionTitle, onboardingQuestionnaire, userId);
      }
      if (question.style === 'single_select') {
        return renderSingleSelect(question.question_text, question.subtext, question.answer, question.question_key, question.answer_options, handleChange);
      }
      break;
    case 'numeric_range':
      if (question.style === 'text_input') {
        return renderNumericRangeTextInput(question.question_text, question.subtext, question.parent_id, question.answer, question.question_key, handleChange, forceSmallQuestionTitle, onboardingQuestionnaire, userId, updateParentError);
      }
      break;
    case 'date_range':
      if (question.style === 'datepicker') {
        return renderDateRangeDateInput(question.question_text, question.subtext, question.parent_id, question.answer, question.question_key, handleChange, forceSmallQuestionTitle, onboardingQuestionnaire);
      }
      break;
    case 'freetext':
    case 'location':
      if (question.style === 'text_input') {
        return renderTextInput(question.question_text, question.subtext, question.parent_id, question.answer, question.question_key, handleChange, forceSmallQuestionTitle, csrfToken, onboardingQuestionnaire);
      }
      if (question.style === 'geosuggest') {
        return renderGeosuggest(question.question_text, question.subtext, question.parent_id, question.answer, question.question_key, handleChange, forceSmallQuestionTitle, onboardingQuestionnaire, userId);
      }
      if (question.style === 'text_area') {
        return renderTextArea(question.question_text, question.subtext, question.parent_id, question.answer, question.question_key.replace(/_/g, ' '), handleChange, forceSmallQuestionTitle, onboardingQuestionnaire);
      }
      if (question.style === 'text_input_group_suffix') {
        return renderTextInputGroupSuffix(question.question_text, question.subtext, question.parent_id, question.answer, question.question_key, question.addon, question.addon_url, handleChange, forceSmallQuestionTitle, csrfToken, onboardingQuestionnaire, userId);
      }
      break;
    case 'file':
      return renderFileUpload(question.question_text, question.subtext, question.resume_url, question.answer, question.question_key, csrfToken, forceSmallQuestionTitle, question.style, onboardingQuestionnaire, handleMenuUpdate, handleNewResume, handleResumeUpload);
    case 'number':
      if (question.style === 'number_input') {
        return renderNumberInput(question.question_text, question.subtext, question.parent_id, question.answer, question.question_key, handleChange, forceSmallQuestionTitle, onboardingQuestionnaire);
      }
      break;
    case 'date':
      return renderDateInput(question.question_text, question.subtext, question.parent_id, question.answer, question.question_key, handleChange, forceSmallQuestionTitle, onboardingQuestionnaire);
    case 'past_roles':
      return renderPastRoles(question.question_text, question.subtext, question.answer, question.question_key, handleChange, closeModal, forceSmallQuestionTitle, saveOnChange, suggestedAnswers && suggestedAnswers[question.question_key], onboardingQuestionnaire, profileQuestionnaire, objectId, isReadingMore, handlePastRolesAfterUpdate);
    case 'boolean':
      return renderBooleanCheckbox(question.question_text, question.subtext, question.parent_id, question.parent, question.answer, question.question_key, question.answer_options[0].label, handleChange, forceSmallQuestionTitle, onboardingQuestionnaire, userId);
    case 'list':
      return renderList(question.question_text, question.subtext, question.answer, question.question_key, handleChange, question.limit, closeModal, question.style, onboardingQuestionnaire);
    case 'group_parent':
      return renderGroupParent(question.question_text, question.subtext, question.answer, question.question_key, handleChange, question.limit, closeModal, question.children_questions, question.parent_id, disabled, handleMenuUpdate, onboardingQuestionnaire, userId);
    case 'proficiency':
      return renderProficiencies(question.question_text, question.subtext, question.answer, question.question_key, question.answer_options, handleChange, question.limit, closeModal, question.style);
    case 'proficiency_ranking':
      return renderProficiencyRankings(question.question_text, question.subtext, question.answer, question.answer_options, handleChange, question.question_key);
    default:
      return null;
  }
  return null;
};
function QuestionRenderer(_ref) {
  var question = _ref.question,
    handleChange = _ref.handleChange,
    handleOtherTextChange = _ref.handleOtherTextChange,
    csrfToken = _ref.csrfToken,
    disabled = _ref.disabled,
    closeModal = _ref.closeModal,
    forceSmallQuestionTitle = _ref.forceSmallQuestionTitle,
    suggestedAnswers = _ref.suggestedAnswers,
    saveOnChange = _ref.saveOnChange,
    questionnaireName = _ref.questionnaireName,
    handleMenuUpdate = _ref.handleMenuUpdate,
    userId = _ref.userId,
    handleNewResume = _ref.handleNewResume,
    updateParentError = _ref.updateParentError,
    objectId = _ref.objectId,
    isReadingMore = _ref.isReadingMore,
    handleResumeUpload = _ref.handleResumeUpload,
    handlePastRolesAfterUpdate = _ref.handlePastRolesAfterUpdate;
  return /*#__PURE__*/React.createElement(Fragment, null, renderQuestion(userId, question, handleChange, handleOtherTextChange, csrfToken, disabled, closeModal, forceSmallQuestionTitle, suggestedAnswers, saveOnChange, questionnaireName, handleMenuUpdate, handleNewResume, updateParentError, objectId, isReadingMore, handleResumeUpload, handlePastRolesAfterUpdate));
}
QuestionRenderer.propTypes = {
  question: PropTypes.shape({}).isRequired,
  handleChange: PropTypes.func.isRequired,
  handleOtherTextChange: PropTypes.func.isRequired,
  csrfToken: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
  closeModal: PropTypes.func,
  forceSmallQuestionTitle: PropTypes.bool,
  suggestedAnswers: PropTypes.shape([]),
  saveOnChange: PropTypes.bool,
  handleMenuUpdate: PropTypes.func,
  questionnaireName: PropTypes.string,
  userId: PropTypes.number,
  handleNewResume: PropTypes.func,
  handleResumeUpload: PropTypes.func,
  updateParentError: PropTypes.func,
  objectId: PropTypes.number,
  isReadingMore: PropTypes.bool,
  handlePastRolesAfterUpdate: PropTypes.func
};
QuestionRenderer.defaultProps = {
  closeModal: function closeModal() {},
  forceSmallQuestionTitle: false,
  saveOnChange: false,
  questionnaireName: 'Consultant Onboarding',
  userId: null,
  objectId: null,
  isReadingMore: false,
  handleNewResume: function handleNewResume() {},
  handleResumeUpload: function handleResumeUpload() {},
  updateParentError: function updateParentError() {},
  handlePastRolesAfterUpdate: function handlePastRolesAfterUpdate() {}
};
export default QuestionRenderer;